// extracted by mini-css-extract-plugin
export default {"root":"_29CFj","content":"_28Sgw"};